export enum EnquiryStatus {
	None = 0, Rejected, Confirmed, PartialApproval
}

export enum EnquiryType {
	Message = 0, Notice
}

export class EnquiryModel {
	constructor(
		public id: string,
		public applicationId: string,
		public username: string,
		public createdAt: Date,
		public message: string,
		public fromClient: boolean,
		public status: EnquiryStatus,
		public type: EnquiryType,
	) { }
}